import React from "react";

const LoaderMini = () => {
  return (
    <div>
      <div data-testid="loader-mini" className="centerMini">
        <div className="spinnerMini" />
      </div>
    </div>
  );
};

export default LoaderMini;
